/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { alertController } from '@ionic/vue';
import { routerPushInterface } from '../services/router.interface';
import AppConst from '../constants/app.constant';

const openbackDoorgate = () => {
  alertController
    .create({
      header: 'Passcode!',
      backdropDismiss: 'false',
      inputs: [
        {
          name: 'dc',
          type: 'string',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
        },
        {
          text: 'Alohomora',
          handler(data) {
            if (data.dc === AppConst.dc1 + AppConst.dc2) {
              routerPushInterface({ name: 'app.developer' });
            }
          },
        },
      ],
    })
    .then((alert) => {
      alert.present();
    });
};

export { openbackDoorgate };
